const React = require('react')
const PropTypes = require('prop-types')

function MetaItem(props) {

    return (
        <li className="meta-item">{props.text}</li>
    )

}

MetaItem.propTypes = {
    text: PropTypes.string.isRequired,
}

module.exports = MetaItem
